// libs
import React from 'react';
import { useParams } from 'react-router-dom';

// components
import CMSWrapper from 'shared/layouts/CMSPage/CMSWrapper';
import Meta from 'shared/layouts/CMSPage/components/Meta';
import View from 'shared/layouts/CMSPage/components/View';

interface CMSProps {
  isMobile: boolean;
  pageId: string;
}

function CMSPage({ isMobile = false, pageId }: Partial<CMSProps>) {
  const { slug } = useParams<{ slug: string }>();
  const pageName = pageId || slug;

  return (
    <CMSWrapper isMobile={isMobile} pageId={pageName}>
      <Meta />
      <View />
    </CMSWrapper>
  );
}

export default CMSPage;
